const Digicert = () => (
  <img alt="Digicert logo" src="/img/customer-logos/digicert-logo-white.svg" />
);

export default Digicert;
